<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="注册时间" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            @change="getTable"
            popper-class="picker-popper">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <VTable
      showIndex
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="false"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:trade_amount="{ row }">
        <span>￥{{ row.trade_amount }}</span>
      </template>
      <template v-slot:merchant_count="{ row }">
        <el-button type="text" @click="viewBind(row)">{{
          row.merchant_count
        }}</el-button>
      </template>
      <template v-slot:action="{ row }">
        <el-button type="text" @click="showDetails(row)">查看</el-button>
        <el-button type="text" @click="editPass(row)">修改密码</el-button>
        <el-button
          v-if="row.status == 1 && !row.merchant_count"
          type="text"
          @click="toDisabled(row)"
          >禁用</el-button
        >
        <el-dropdown
          v-if="row.status == 1 && row.merchant_count"
          placement="bottom-end"
          @command="handleCommand($event, row)"
          style="margin-left: 10px"
        >
          <el-button v-if="row.status == 1 && row.merchant_count" type="text"
            >禁用</el-button
          >
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">直接禁用</el-dropdown-item>
            <el-dropdown-item command="2">转移并禁用</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="row.status == 2"
          type="text"
          @click="toNotDisabled(row)"
          >启用</el-button
        >
      </template>
    </VTable>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "salesmanIndex",
  components: {
    VTable,
  },
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "phone", label: "用户手机号", hidden: false },
        { name: "createat", label: "注册时间", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          date:'',
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/user/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.user-list {
  max-height: 300px;
  overflow: auto;
}
.user {
  height: 30px;
  line-height: 30px;
}
</style>
